import React, { useState, useEffect } from 'react';
import { 
  Stack,
  Alert,
  Text
} from '@mantine/core';
import LabeledSelect from './LabeledSelect';
import { useTranslation } from 'react-i18next';

/**
 * 컬렉션 선택 모드
 * - 'none': 컬렉션에 추가하지 않음
 * - 'existing': 기존 컬렉션 선택
 * - 'new': 새 컬렉션 생성
 */
const CollectionSelector = ({ 
  value = {}, 
  onChange, 
  collections = [], 
  loading = false,
  disabled = false
}) => {
  const { t } = useTranslation();
  console.log('CollectionSelector rendered with props:', { value, collections, loading, disabled });

  const [selectedCollectionId, setSelectedCollectionId] = useState(value.collectionId || '');

  // 부모 컴포넌트에 값 전달
  useEffect(() => {
    try {
      const collectionData = {
        mode: selectedCollectionId ? 'existing' : 'none',
        autoAddToCollection: !!selectedCollectionId, // 컬렉션 선택 시 자동으로 true
        ...(selectedCollectionId && { collectionId: selectedCollectionId })
      };
      
      if (onChange && typeof onChange === 'function') {
        onChange(collectionData);
      }
    } catch (error) {
      console.error('CollectionSelector onChange error:', error);
    }
  }, [selectedCollectionId, onChange]);

  // 컬렉션 선택 옵션 생성
  const collectionOptions = collections.map(collection => ({
    value: collection.id,
    label: `${collection.title} (${collection.threadList?.length || 0}개 스레드)`,
    description: collection.description?.substring(0, 50) + (collection.description?.length > 50 ? '...' : '')
  }));

  // 컬렉션 선택 변경 핸들러
  const handleCollectionChange = (collectionId) => {
    setSelectedCollectionId(collectionId);
  };

  // 선택된 컬렉션 정보 가져오기
  const selectedCollection = collections.find(c => c.id === selectedCollectionId);

  return (
    <Stack spacing="sm">
      {/* 컬렉션 선택 */}
      <LabeledSelect
        label={t("postThreads.collection.title")}
        placeholder={t("postThreads.collection.placeholder")}
        value={selectedCollectionId}
        onChange={handleCollectionChange}
        disabled={disabled || loading}
        data={[
          { value: '', label: t("postThreads.collection.noSelection") },
          ...collectionOptions
        ]}
        searchable
        clearable
        nothingFound={collections.length === 0 ? t("postThreads.collection.noCollections") : t("postThreads.collection.noSearchResults")}
        maxDropdownHeight={200}
      />

      {/* 선택된 컬렉션 정보 */}
      {selectedCollection && (
        <Alert variant="light">
          <Text size="xs">
            {t("postThreads.collection.addToCollection", { title: selectedCollection.title })}
            <br />
            {t("postThreads.collection.currentThreads", { count: selectedCollection.threadList?.length || 0 })}
          </Text>
        </Alert>
      )}
    </Stack>
  );
};

export default CollectionSelector;